var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductInstellingen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.681,
    height: 49.151,
    viewBox: "0 0 46.681 49.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ProductInstellingen",
    transform: "translate(-882.457 -567.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_fa-solid-gear",
    "data-name": "Icon fa-solid-gear",
    d: "M44.418,15.02a2.042,2.042,0,0,1-.577,2.218l-3.9,3.552a17.184,17.184,0,0,1,0,4.58l3.9,3.552a2.042,2.042,0,0,1,.577,2.218,22.346,22.346,0,0,1-1.424,3.092l-.424.73a22.941,22.941,0,0,1-1.992,2.813,2.042,2.042,0,0,1-2.209.613l-5.022-1.6a17.348,17.348,0,0,1-3.967,2.29l-1.127,5.148a2.038,2.038,0,0,1-1.641,1.6,23.422,23.422,0,0,1-7.663,0,2.038,2.038,0,0,1-1.641-1.6l-1.127-5.148a17.348,17.348,0,0,1-3.967-2.29L7.2,38.4a2.058,2.058,0,0,1-2.209-.613A22.941,22.941,0,0,1,3,34.972l-.424-.73a22.347,22.347,0,0,1-1.424-3.092,2.042,2.042,0,0,1,.577-2.218l3.9-3.552a17.688,17.688,0,0,1-.153-2.3,17.445,17.445,0,0,1,.153-2.29l-3.9-3.552a2.042,2.042,0,0,1-.577-2.218,22.347,22.347,0,0,1,1.424-3.092L3,11.2A22.941,22.941,0,0,1,4.992,8.385,2.042,2.042,0,0,1,7.2,7.771l5.022,1.6a17.348,17.348,0,0,1,3.967-2.29l1.127-5.148a2.038,2.038,0,0,1,1.641-1.6A22.349,22.349,0,0,1,22.789,0a23.3,23.3,0,0,1,3.832.316,2.038,2.038,0,0,1,1.641,1.6l1.127,5.148a17.348,17.348,0,0,1,3.967,2.29l5.022-1.6a2.058,2.058,0,0,1,2.209.613,22.941,22.941,0,0,1,1.992,2.813l.424.73a22.348,22.348,0,0,1,1.424,3.092Z",
    transform: "translate(882.971 569.462)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-package",
    "data-name": "Icon feather-package",
    transform: "translate(892.211 579.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M18.394,10.617,9.131,5.275M23.025,17.409V9.176A2.058,2.058,0,0,0,22,7.4l-7.2-4.117a2.058,2.058,0,0,0-2.058,0L5.529,7.4A2.058,2.058,0,0,0,4.5,9.176v8.233a2.058,2.058,0,0,0,1.029,1.78l7.2,4.117a2.058,2.058,0,0,0,2.058,0L22,19.19a2.058,2.058,0,0,0,1.029-1.78Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M4.905,10.44l8.985,5.2,8.985-5.2M13.89,26V15.627",
    transform: "translate(-0.127 -2.334)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductInstellingen);
export default __webpack_public_path__ + "static/media/ProductInstellingen.3573bdfa98cc497b5c90aa79eaf85907.svg";
export { ForwardRef as ReactComponent };